import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import Orders from "./orders";

const feature = "orders";

const InitialState = Record({
  orders: new Orders()
});

const START = "_START";
const SUCCESS = "_SUCCESS";
const ERROR = "_ERROR";

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function OrdersReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
        action.payload.entities &&
        action.payload.entities.orders
    ) {
      state = state.updateIn(["orders", "entities"], map =>
        map.mergeDeep(action.payload.entities.orders));
    }
  }

  switch (action.type) {
    case actions.GET_ORDERS + START: {
      return state.setIn(["orders", "loading"], true);
    }
    case actions.GET_ORDERS + SUCCESS: {
      state = state.deleteIn(["orders", "entities"]);
      state = state.deleteIn(["orders", "results"]);
      state = state.setIn(
        ["orders", "meta", "all"],
        action.payload.result.meta.all
      );
      state = state.setIn(
        ["orders", "meta", "count"],
        action.payload.result.meta.count
      );
      state = state.updateIn(["orders", "entities"], map =>
        map.mergeDeep(action.payload.entities.orders));
      state = state.setIn(["orders", "results"], action.payload.result.orders);
      return state.setIn(["orders", "loading"], false);
    }
    case actions.GET_ORDERS + ERROR: {
      return state.setIn(["orders", "loading"], false);
    }

    case actions.GET_ORDER + START: {
      return state.setIn(["orders", "loading"], true);
    }
    case actions.GET_ORDER + SUCCESS: {
      return state.setIn(["orders", "loading"], false);
    }
    case actions.GET_ORDER + ERROR: {
      return state.setIn(["orders", "loading"], false);
    }

    case actions.PATCH_ORDERS + START: {
      return state.setIn(["orders", "loading"], true);
    }
    case actions.PATCH_ORDERS + SUCCESS: {
      return state.setIn(["orders", "loading"], false);
    }
    case actions.PATCH_ORDERS + ERROR: {
      return state.setIn(["orders", "loading"], false);
    }

    case actions.DELETE_ORDER + START: {
      return state.deleteIn(["orders", "entities", action.payload.uid]);
    }

    case actions.SET_IS_REMOVE_ORDER_MODAL_VISIBLE: {
      return state.setIn(
        ["orders", "isRemoveModalVisible"],
        action.data.isVisble
      );
    }
    case actions.SET_IS_EDIT_ORDER_MODAL_VISIBLE: {
      return state.setIn(
        ["orders", "isEditModalVisible"],
        action.data.isVisble
      );
    }
  }

  return entitiesReducer(state, feature, action);
}



// WEBPACK FOOTER //
// ./src/common/orders/reducer.js